import RadiusLoc from '@/core/components/RadiusLoc/RadiusLoc';

export default RadiusLoc;
